import './style.scss';
import { Teams } from './Teams';
import { TeamDetails } from './Create/TeamDetails/TeamDetails';
import { TeamUsers } from './Create/TeamUsers/TeamUsers';
import { TeamProducts } from './Create/TeamProducts/TeamProducts';
import { EditTeamDetails } from './Create/TeamDetails/EditTeamDetails';
import { TruRoute } from '../../../TruRoute';
import { lazy, Suspense, useCallback } from 'react';
import { LoadingPage } from '@trufla-technology/trumarket-react-design-system';
import { Switch } from 'react-router-dom';
const TeamPermissions = lazy(() =>
  import('./Create/TeamPermissions/TeamPermissions').then(
    ({ TeamPermissions }) => ({ default: TeamPermissions }),
  ),
);

export type SearchObject = {
  searchValue: string;
};
export const TeamsRoutes = () => {
  const MemoizedTeamUser = useCallback(() => <TeamUsers mode="edit" />, []);
  const MemoizedTeamPermissions = useCallback(
    () => <TeamPermissions mode="edit" />,
    [],
  );
  const MemoizedTeamProducts = useCallback(
    () => <TeamProducts mode="edit" />,
    [],
  );

  return (
    <div className="teams-page">
      <Suspense
        fallback={
          <div className="loader-div">
            <LoadingPage />
          </div>
        }
      >
        <Switch>
          <TruRoute
            permission={['createTeam']}
            path="/configurations/teams/create"
            component={TeamDetails}
          />
          <TruRoute
            permission={['getCompany', 'listTeamRoles']}
            path="/configurations/teams/team-permissions/create/:teamKey"
            component={TeamPermissions}
          />
          <TruRoute
            permission={['getProductDefinitionByKey', 'listRequestDefinitions']}
            path="/configurations/teams/team-products/create/:teamKey"
            component={TeamProducts}
          />
          <TruRoute
            permission={['getUserByKey']}
            path="/configurations/teams/team-users/create/:teamKey"
            component={TeamUsers}
          />
          <TruRoute
            permission={['getTeams']}
            path="/configurations/teams/details/:teamKey"
            component={EditTeamDetails}
          />
          <TruRoute
            permission={['getUserByKey']}
            path="/configurations/teams/team-users/:teamKey"
            component={MemoizedTeamUser}
          />
          <TruRoute
            permission={['getCompany', 'listTeamRoles']}
            path="/configurations/teams/team-permissions/:teamKey"
            component={MemoizedTeamPermissions}
          />
          <TruRoute
            permission={['getProductDefinitionByKey', 'listRequestDefinitions']}
            path="/configurations/teams/team-products/:teamKey"
            component={MemoizedTeamProducts}
          />
          <TruRoute
            permission={['getTeams']}
            path="/configurations/teams"
            component={Teams}
          />
        </Switch>
      </Suspense>
    </div>
  );
};
